import { PREFIX } from '@src/constants';

export const logout = async (eapiBaseUrl: string) => {
	const redisSessionManagementDisabled = process.env.NEXT_PUBLIC_DISABLE_REDIS_SESSIONS === 'true';

	if (!redisSessionManagementDisabled) {
		try {
			await fetch(`${PREFIX}/delete-session/`, {
				method: 'POST',
				credentials: 'include',
			});
		} catch {}
	}
	return await fetch(`${eapiBaseUrl}identity/logout`, { credentials: 'include' });
};
